import {InputTextV2} from '@prtimes-basis/input';
import styles from './capital-field.module.css';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function CapitalField() {
  return (
    <FormField.Root name='companyInfo.capital'>
      <div className={styles.container}>
        <Body />
        <p className={companyRegistrationPageStyles.textXs}>万円</p>
      </div>

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return <InputTextV2 wrapperClassName={styles.input} {...fieldProps} />;
}
